import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import LoadingSpinner from '../LoadingSpinner';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, authInProgress } = useAuth();
  const location = useLocation();

  // Show loading spinner while authentication is in progress
  if (authInProgress) {
    return <LoadingSpinner message="Authenticating..." />;
  }

  // For routes that require authentication but not specific permissions
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute; 